module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/construction-mobile-e406c21f91df5e4dfc2ffaa3512da9b6.png";